import { useToken } from '@gluestack-ui/themed';

export type ChartTheme = {
  series: string;
  corridor: string;
  bandFill: string;
  grid: string;
  axis: string;
  heading: string;
  helpful: string;
  notHelpful: string;
  release: string;
  surface: string;
  mutedFigure: string;
  textOnSuccess: string;
  fontFamily: string;
};

/* eslint-disable react-hooks/rules-of-hooks */
function color(name: string): string {
  // @ts-expect-error semantic tokens are not in the typed token map
  return useToken('colors', name) as string;
}
/* eslint-enable react-hooks/rules-of-hooks */

/**
 * Resolves semantic chart colours to hex and sets Inter for axis text (Recharts).
 */
export function useChartTheme(): ChartTheme {
  return {
    series: color('brandBase'),
    corridor: color('brandBase'),
    bandFill: `${color('textSubtle')}33`,
    grid: color('borderLight'),
    axis: color('textSubtle'),
    heading: color('textHeading'),
    helpful: color('statusSuccess'),
    notHelpful: `${color('statusError')}59`,
    release: color('statusInfo'),
    surface: color('bgCard'),
    mutedFigure: color('textDisabled'),
    textOnSuccess: color('textOnSuccess'),
    fontFamily: 'Inter-Regular, Inter, system-ui, sans-serif',
  };
}

/** Returns true when every theme colour value is a #hex string. */
export function chartThemeColorsAreHex(theme: ChartTheme): boolean {
  const hex = /^#[0-9A-Fa-f]{6}([0-9A-Fa-f]{2})?$/;
  return Object.entries(theme).every(([key, value]) => {
    if (key === 'fontFamily') return typeof value === 'string' && value.length > 0;
    return hex.test(value);
  });
}
